// extracted by mini-css-extract-plugin
export default {"operationArea":"Role_operationArea__NgfTQ"};